export default __webpack_public_path__ + "static/media/create_group_icon.f3293274.svg";